<div style="display: flex;flex-direction: row;justify-content: space-between;">
    <p>Doctor Notes</p>
    <img (click)="close()" src="assets/cancel.svg">
</div>